import React, { Component } from 'react';
import { FaUserAlt } from 'react-icons/fa';
import { BiLoaderAlt } from 'react-icons/bi';
import { Redirect, withRouter } from 'react-router-dom';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import Button from '../../components/Button';
import ModuloTeste from '../../components/ModuloTeste';

import '../TestePaciente/style.css';
import { fetchApi } from '../../services/api';
import Loading from '../../components/Loading';
import Alert from '../../components/Alert';
import { getLink } from '../../services/host';

class TestePaciente extends Component {
  timer = null;

  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id !== undefined ? props.match.params.id : null,
      module_complete: 0,
      isLoading: false,
      id_paciente: null,
      nome_paciente: null,
      escolaridade: null,
      nascimento: null,
      idade: '',
      idade_teste: '',
      data_teste: '-',
      show_diagnostico: false,
      module_processing: [false, false, false],
      module_needs_validation: [false, false, false],
      is_processing: false,
      successMessages: [],
      errorMessages: [],
    };

    this.showDiagnostico = this.showDiagnostico.bind(this);
    this.checkProcessing = this.checkProcessing.bind(this);
  }

  componentDidMount() {
    document.title = `Módulos`;
    window.scrollTo(0, 0);

    this.carregaDados();

    //timer para verifica se tem algum modulo processando
    this.checkProcessing();
    this.timer = setInterval(() => {
      this.checkProcessing();
    }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  carregaDados() {
    this.setState({ isLoading: true });

    fetchApi
      .get(
        process.env.REACT_APP_INSTITUCIONAL_TESTE_LISTA_MODULOS,
        this.props.match.params.id_pesquisador,
        this.props.match.params.id_paciente,
        this.props.match.params.id_teste,
      )
      .then((response) => {
        if (response.data.status === 'success') {
          this.setState({
            module_complete: response.data.modulos,
            id_paciente: response.data.paciente.id_paciente,
            nascimento: response.data.paciente.nascimento,
            idade: response.data.idade,
            idade_teste: response.data.idade_teste,
            escolaridade: response.data.paciente.escolaridade,
            nome_paciente: response.data.paciente.nome,
            data_teste: response.data.teste.created_at,
          });
        }
      })
      .catch((err) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  showDiagnostico(e) {
    e.preventDefault();

    if (!this.state.is_processing) {
      //redireciona para pagina de diagnostico
      this.setState({
        show_diagnostico: true,
      });
    } else {
      window.scrollTo(0, 0);

      this.setState({
        errorMessages: [
          'O servidor está processando os dados do teste. Por favor, aguarde e tente novamente.',
        ],
      });
    }
  }

  checkProcessing() {
    //valida se existe alguma resposta nao processada
    fetchApi
      .get(
        process.env.REACT_APP_INSTITUCIONAL_TESTE_VALIDA_PROCESSAMENTO,
        this.props.match.params.id_pesquisador,
        this.props.match.params.id_paciente,
        this.props.match.params.id_teste,
      )
      .then((response) => {
        if (response.data.status === 'success') {
          //seta dados e para de atualizar
          this.setState({
            module_processing: response.data.processing,
            module_needs_validation: response.data.needValidation,
            is_processing: false,
          });

          clearInterval(this.timer);
        } else {
          this.setState({
            module_processing: response.data.processing,
            module_needs_validation: response.data.needValidation,
            is_processing: response.data.processing.includes(true)
              ? true
              : false,
          });
        }
      });
  }

  needValidation = () => this.state.module_needs_validation.includes(true);

  render() {
    var content = [];
    for (var i = 1; i < 4; i++) {
      if (this.state.module_complete >= i) {
        content.push(
          <ModuloTeste
            key={i}
            id_teste={this.props.match.params.id_teste}
            modulo={`Módulo ${i}`}
            status={1}
            n_modulo={i}
            isLoading={this.state.module_processing[i - 1]}
            need_validation={this.state.module_needs_validation[i - 1]}
            id_pesquisador={this.props.match.params.id_pesquisador}
            id_paciente={this.props.match.params.id_paciente}
          />,
        );
      } else {
        content.push(
          <ModuloTeste
            key={i}
            id_teste={this.props.match.params.id_teste}
            modulo={`Módulo ${i}`}
            status={0}
            n_modulo={i}
            isLoading={this.state.module_processing[i - 1]}
            need_validation={this.state.module_needs_validation[i - 1]}
            id_pesquisador={this.props.match.params.id_pesquisador}
            id_paciente={this.props.match.params.id_paciente}
          />,
        );
      }
    }

    return (
      <div>
        <Header />
        <div className="content">
          <TopPage
            title={this.state.nome_paciente}
            back={getLink(
              `/pesquisador/${this.props.match.params.id_pesquisador}/paciente/${this.props.match.params.id_paciente}/testes`,
            )}
            small={`Data de nascimento: ${this.state.nascimento} - ${this.state.idade}`}
            small2={`Idade ao realizar o teste: ${this.state.idade_teste}`}
            small3={`Escolaridade: ${this.state.escolaridade}`}
            small4={`Data do teste: ${this.state.data_teste}`}
            icon={true}
          >
            <FaUserAlt />
          </TopPage>

          <div id="salvar-observacao">
            {this.state.successMessages.length > 0 ? (
              <Alert tipo="success" messages={this.state.successMessages} />
            ) : null}
            {this.state.errorMessages.length > 0 ? (
              <Alert tipo="error" messages={this.state.errorMessages} />
            ) : null}

            {content.map((value) => {
              return value;
            })}

            {this.needValidation() && (
              <Alert
                tipo="warning center"
                messages={['Existem respostas a serem validadas.']}
              />
            )}

            {this.state.module_complete >= 3 && !this.needValidation() ? (
              <div>
                <div className="align-buttons">
                  <Button
                    type="button"
                    id="ver-resultado"
                    icon={
                      this.state.is_processing ? (
                        <div
                          className="loading-module"
                          style={{
                            position: 'relative',
                            width: 'auto',
                            height: 'auto',
                          }}
                        >
                          <BiLoaderAlt />
                        </div>
                      ) : null
                    }
                    name="ver-resultado"
                    onClick={this.showDiagnostico}
                  >
                    Ver Resultado
                  </Button>
                </div>
              </div>
            ) : null}
          </div>
        </div>

        {this.state.isLoading ? <Loading /> : null}

        {this.state.show_diagnostico !== false ? (
          <Redirect
            to={getLink(
              `/pesquisador/${this.props.match.params.id_pesquisador}/paciente/${this.props.match.params.id_paciente}/teste/${this.props.match.params.id_teste}/diagnostico`,
            )}
          />
        ) : null}

        <Footer />
      </div>
    );
  }
}

export default withRouter(TestePaciente);
